// First-session copy for the active locales (_lang_pick.html.haml); mx uses es, anything else falls back to en.
const translations = {
  en: {
    panelTitle: 'Start from a working circuit',
    panelSubtitle: 'Open one, switch it on, then change it.',
    starters: {
      led: 'Light an LED',
      diode: 'How a diode works',
      ohm: "Ohm's law with a multimeter"
    },
    openStarter: 'Open the circuit: {title}',
    checklistTitle: 'Your first circuit',
    pill: 'First circuit {done}/{total}',
    steps: {
      place: 'Place a part',
      wire: 'Connect it with a wire',
      run: 'Run the simulation',
      meter: 'Read a meter',
      save: 'Save your circuit'
    },
    stepDone: 'done',
    stepPending: 'to do',
    collapse: 'Collapse',
    expand: 'Expand',
    closePanel: 'Close the starter circuits',
    closeChecklist: 'Close the checklist'
  },
  es: {
    panelTitle: 'Empieza con un circuito que funciona',
    panelSubtitle: 'Ábrelo, enciéndelo y luego modifícalo.',
    starters: {
      led: 'Enciende un LED',
      diode: 'Cómo funciona un diodo',
      ohm: 'Ley de Ohm con un multímetro'
    },
    openStarter: 'Abrir el circuito: {title}',
    checklistTitle: 'Tu primer circuito',
    pill: 'Primer circuito {done}/{total}',
    steps: {
      place: 'Coloca un componente',
      wire: 'Conéctalo con un cable',
      run: 'Ejecuta la simulación',
      meter: 'Lee un medidor',
      save: 'Guarda tu circuito'
    },
    stepDone: 'hecho',
    stepPending: 'pendiente',
    collapse: 'Contraer',
    expand: 'Expandir',
    closePanel: 'Cerrar los circuitos de inicio',
    closeChecklist: 'Cerrar la lista'
  },
  de: {
    panelTitle: "Starte mit einer funktionierenden Schaltung",
    panelSubtitle: "Öffne eine, schalte sie ein und ändere sie dann.",
    starters: {
      led: "Eine LED leuchten lassen",
      diode: "So funktioniert eine Diode",
      ohm: "Ohmsches Gesetz mit einem Multimeter"
    },
    openStarter: "Schaltung öffnen: {title}",
    checklistTitle: "Deine erste Schaltung",
    pill: "Erste Schaltung {done}/{total}",
    steps: {
      place: "Ein Bauteil platzieren",
      wire: "Mit einem Draht verbinden",
      run: "Simulation starten",
      meter: "Ein Messgerät ablesen",
      save: "Schaltung speichern"
    },
    stepDone: "erledigt",
    stepPending: "offen",
    collapse: "Einklappen",
    expand: "Ausklappen",
    closePanel: "Startschaltungen schließen",
    closeChecklist: "Checkliste schließen"
  },
  ar: {
    panelTitle: "ابدأ بدائرة تعمل",
    panelSubtitle: "افتح واحدة، شغّلها، ثم عدّلها.",
    starters: {
      led: "أضئ مصباح LED",
      diode: "كيف يعمل الثنائي",
      ohm: "قانون أوم باستخدام جهاز متعدد القياس"
    },
    openStarter: "افتح الدائرة: {title}",
    checklistTitle: "دائرتك الأولى",
    pill: "الدائرة الأولى {done}/{total}",
    steps: {
      place: "ضع مكونًا",
      wire: "صِله بسلك",
      run: "شغّل المحاكاة",
      meter: "اقرأ جهاز قياس",
      save: "احفظ دائرتك"
    },
    stepDone: "تم",
    stepPending: "لم يتم بعد",
    collapse: "طيّ",
    expand: "توسيع",
    closePanel: "إغلاق دوائر البداية",
    closeChecklist: "إغلاق قائمة المهام"
  },
  tr: {
    panelTitle: "Çalışan bir devreyle başla",
    panelSubtitle: "Birini aç, çalıştır, sonra değiştir.",
    starters: {
      led: "Bir LED yak",
      diode: "Diyot nasıl çalışır",
      ohm: "Multimetre ile Ohm yasası"
    },
    openStarter: "Devreyi aç: {title}",
    checklistTitle: "İlk devren",
    pill: "İlk devre {done}/{total}",
    steps: {
      place: "Bir parça yerleştir",
      wire: "Bir kabloyla bağla",
      run: "Simülasyonu çalıştır",
      meter: "Bir ölçü aletini oku",
      save: "Devreni kaydet"
    },
    stepDone: "tamam",
    stepPending: "yapılacak",
    collapse: "Daralt",
    expand: "Genişlet",
    closePanel: "Başlangıç devrelerini kapat",
    closeChecklist: "Kontrol listesini kapat"
  },
  fr: {
    panelTitle: "Commencez avec un circuit qui fonctionne",
    panelSubtitle: "Ouvrez-en un, allumez-le, puis modifiez-le.",
    starters: {
      led: "Allumer une LED",
      diode: "Comment fonctionne une diode",
      ohm: "La loi d'Ohm avec un multimètre"
    },
    openStarter: "Ouvrir le circuit : {title}",
    checklistTitle: "Votre premier circuit",
    pill: "Premier circuit {done}/{total}",
    steps: {
      place: "Placez un composant",
      wire: "Reliez-le avec un fil",
      run: "Lancez la simulation",
      meter: "Lisez un instrument de mesure",
      save: "Enregistrez votre circuit"
    },
    stepDone: "fait",
    stepPending: "à faire",
    collapse: "Réduire",
    expand: "Développer",
    closePanel: "Fermer les circuits de départ",
    closeChecklist: "Fermer la liste"
  },
  th: {
    panelTitle: "เริ่มจากวงจรที่ใช้งานได้",
    panelSubtitle: "เปิดวงจร เปิดสวิตช์ แล้วลองแก้ไข",
    starters: {
      led: "ทำให้ LED สว่าง",
      diode: "ไดโอดทำงานอย่างไร",
      ohm: "กฎของโอห์มด้วยมัลติมิเตอร์"
    },
    openStarter: "เปิดวงจร: {title}",
    checklistTitle: "วงจรแรกของคุณ",
    pill: "วงจรแรก {done}/{total}",
    steps: {
      place: "วางอุปกรณ์",
      wire: "ต่อด้วยสายไฟ",
      run: "เริ่มการจำลอง",
      meter: "อ่านค่าจากเครื่องวัด",
      save: "บันทึกวงจรของคุณ"
    },
    stepDone: "เสร็จแล้ว",
    stepPending: "ยังไม่ทำ",
    collapse: "ย่อ",
    expand: "ขยาย",
    closePanel: "ปิดวงจรเริ่มต้น",
    closeChecklist: "ปิดรายการตรวจสอบ"
  },
  pt: {
    panelTitle: "Comece com um circuito que funciona",
    panelSubtitle: "Abra um, ligue-o e depois altere-o.",
    starters: {
      led: "Acenda um LED",
      diode: "Como funciona um díodo",
      ohm: "Lei de Ohm com um multímetro"
    },
    openStarter: "Abrir o circuito: {title}",
    checklistTitle: "O seu primeiro circuito",
    pill: "Primeiro circuito {done}/{total}",
    steps: {
      place: "Coloque um componente",
      wire: "Ligue-o com um fio",
      run: "Execute a simulação",
      meter: "Leia um instrumento de medição",
      save: "Guarde o seu circuito"
    },
    stepDone: "feito",
    stepPending: "por fazer",
    collapse: "Recolher",
    expand: "Expandir",
    closePanel: "Fechar os circuitos iniciais",
    closeChecklist: "Fechar a lista"
  },
  bg: {
    panelTitle: "Започнете с работеща схема",
    panelSubtitle: "Отворете една, включете я и след това я променете.",
    starters: {
      led: "Запалете светодиод",
      diode: "Как работи диодът",
      ohm: "Законът на Ом с мултицет"
    },
    openStarter: "Отворете схемата: {title}",
    checklistTitle: "Вашата първа схема",
    pill: "Първа схема {done}/{total}",
    steps: {
      place: "Поставете елемент",
      wire: "Свържете го с проводник",
      run: "Пуснете симулацията",
      meter: "Отчетете измервателен уред",
      save: "Запазете схемата си"
    },
    stepDone: "готово",
    stepPending: "предстои",
    collapse: "Свиване",
    expand: "Разгъване",
    closePanel: "Затваряне на началните схеми",
    closeChecklist: "Затваряне на списъка"
  },
  ro: {
    panelTitle: "Începe cu un circuit care funcționează",
    panelSubtitle: "Deschide unul, pornește-l, apoi modifică-l.",
    starters: {
      led: "Aprinde un LED",
      diode: "Cum funcționează o diodă",
      ohm: "Legea lui Ohm cu un multimetru"
    },
    openStarter: "Deschide circuitul: {title}",
    checklistTitle: "Primul tău circuit",
    pill: "Primul circuit {done}/{total}",
    steps: {
      place: "Plasează o componentă",
      wire: "Conecteaz-o cu un fir",
      run: "Pornește simularea",
      meter: "Citește un aparat de măsură",
      save: "Salvează circuitul"
    },
    stepDone: "gata",
    stepPending: "de făcut",
    collapse: "Restrânge",
    expand: "Extinde",
    closePanel: "Închide circuitele de pornire",
    closeChecklist: "Închide lista"
  },
  id: {
    panelTitle: "Mulai dari rangkaian yang berfungsi",
    panelSubtitle: "Buka salah satu, nyalakan, lalu ubah.",
    starters: {
      led: "Nyalakan LED",
      diode: "Cara kerja dioda",
      ohm: "Hukum Ohm dengan multimeter"
    },
    openStarter: "Buka rangkaian: {title}",
    checklistTitle: "Rangkaian pertamamu",
    pill: "Rangkaian pertama {done}/{total}",
    steps: {
      place: "Letakkan komponen",
      wire: "Hubungkan dengan kabel",
      run: "Jalankan simulasi",
      meter: "Baca alat ukur",
      save: "Simpan rangkaianmu"
    },
    stepDone: "selesai",
    stepPending: "belum",
    collapse: "Ciutkan",
    expand: "Luaskan",
    closePanel: "Tutup rangkaian awal",
    closeChecklist: "Tutup daftar periksa"
  },
  my: {
    panelTitle: "Mulakan dengan litar yang berfungsi",
    panelSubtitle: "Buka satu, hidupkan, kemudian ubah.",
    starters: {
      led: "Nyalakan LED",
      diode: "Cara diod berfungsi",
      ohm: "Hukum Ohm dengan multimeter"
    },
    openStarter: "Buka litar: {title}",
    checklistTitle: "Litar pertama anda",
    pill: "Litar pertama {done}/{total}",
    steps: {
      place: "Letakkan komponen",
      wire: "Sambungkan dengan wayar",
      run: "Jalankan simulasi",
      meter: "Baca alat pengukur",
      save: "Simpan litar anda"
    },
    stepDone: "selesai",
    stepPending: "belum",
    collapse: "Kecilkan",
    expand: "Kembangkan",
    closePanel: "Tutup litar permulaan",
    closeChecklist: "Tutup senarai semak"
  },
  zh: {
    panelTitle: "从一个能运行的电路开始",
    panelSubtitle: "打开一个电路，接通电源，然后修改它。",
    starters: {
      led: "点亮一个 LED",
      diode: "二极管的工作原理",
      ohm: "用万用表验证欧姆定律"
    },
    openStarter: "打开电路：{title}",
    checklistTitle: "你的第一个电路",
    pill: "第一个电路 {done}/{total}",
    steps: {
      place: "放置一个元件",
      wire: "用导线连接",
      run: "运行仿真",
      meter: "读取仪表读数",
      save: "保存你的电路"
    },
    stepDone: "已完成",
    stepPending: "待完成",
    collapse: "收起",
    expand: "展开",
    closePanel: "关闭入门电路",
    closeChecklist: "关闭清单"
  }
};
// The lab serves Mexico as its own locale with the Spanish copy
translations.mx = translations.es;

export const getTranslations = (locale) => translations[locale] || translations.en;

export const isRTLLocale = (locale) => locale === 'ar';

export const format = (template, values) =>
  Object.keys(values).reduce((text, key) => text.replace(`{${key}}`, () => String(values[key])), template);

export default translations;
